<template>
  <div>
    <mt-header fixed title="进阶指标" class="title1">
      <mt-button slot="left" icon="back" @click="standardBackClickHandler">返回</mt-button>
    </mt-header>
    <div class="stand-table-tip" v-if="tipIsShow">{{ tipValue }}</div>
    <div class="overview-table" v-for="(row, idx) in table" :key="idx">
      <div class="table-header">
        <div></div>
        <div>{{ row.name }}</div>
      </div>
      <div class="stand-table-bodyer">
        <div class="inline-cell" v-for="(cell, k) in row.content" :key="k">
          <div>
            <span>{{ cell.value }}</span>
          </div>
          <div>
            <span>{{ cell.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT */

import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { AdvancedTarget } from '@/api/reward';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'Standard',
  data() {
    return {
      table: [],
      listData: [
        {
          isNum: '99',
          targetName: '人力指标',
          isName: '已达成(人)',
          needNum: '100',
          needName: '直推伙伴(人)',
          restNum: '1',
          restName: '差额(人)',
        },
        {
          isNum: '99.00',
          targetName: '当月业绩指标',
          isName: '已达成(元)',
          needNum: '100.00',
          needName: '交易额(元)',
          restNum: '1.00',
          restName: '差额(元)',
        },
      ],
      currentProduct: '',
      tipIsShow: false,
      tipValue: '',
    };
  },
  mounted() {
    // 控制tip是否显示
    this.currentProduct = PUBLIC_PRODUCT.toLowerCase().trim();
    this.tipIsShow = this.currentProduct === 'cxyfzs';
    // 控制接口开关
    switch (this.$store.state.INTERFACE_ON_OFF) {
      case 'on':
        this.getAdvancedTarget();
        break;
      case 'off':
        this.dataRebuild();
        break;
    }
  },
  methods: {
    getAdvancedTarget() {
      Indicator.open();
      AdvancedTarget()
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            if (this.currentProduct === 'cxyfzs' || this.currentProduct === 'cxyf') {
              this.tipValue = res.data.nowLevel;
              this.listData = res.data.base;
            } else {
              this.listData = res.rows;
            }
            this.dataRebuild();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    dataRebuild() {
      this.table = [];
      this.listData.forEach(item => {
        const obj = {
          name: item.targetName,
          content: [
            { label: item.needName, value: item.needNum },
            { label: item.isName, value: item.isNum },
            { label: item.restName, value: item.restNum },
          ],
        };
        this.table.push(obj);
      });
    },
    standardBackClickHandler() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
